import React, { Fragment, useState } from 'react';
import { Table, ModalBody, Modal, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Accordion from '../../components/common/Accordion';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';
import fieldProps from './fieldProps';
import { startSaveContract, startDeleteContract } from '../../actions/contracts';
import ContractControls from './ContractControls';
import ContractsForm from './ContractsForm';
import ContractStatus from './ContractStatus';
import ContractShipping from './ContractShipping';
import DialogModal from '../../modals/DialogModal/DialogModal';

const customLabelIds = {
  self: {
    name: 0,
    address: 2,
    actual_address: 1,
  },
  ip: {
    name: 0,
    address: 0,
    actual_address: 0,
  },
  ooo: {
    name: 1,
    address: 1,
    actual_address: 0,
  },
};

const AddedContracts = ({
  contracts,
  types,
  typeIndex,
  error,
  startSaveContract,
  showAlert,
  startDeleteContract,
  intl,
}) => {
  const [dataToRemove, catchRemoveData] = useState({});
  const [isRemoveModalOpen, toggleRemoveModal] = useState(false);
  const [isEditModalOpen, toggleEditModal] = useState(false);
  const [selected, selectContract] = useState(null);

  const handleRemoveData = (contractType, id) => catchRemoveData({ contractType, id });
  const toggleRemove = (contractType, id) => {
    if (!isRemoveModalOpen) {
      handleRemoveData(contractType, id);
    } else {
      handleRemoveData({});
    }
    toggleRemoveModal(!isRemoveModalOpen);
  };
  const removeContract = (contractType, id) => {
    startDeleteContract(contractType, id).then(() => {
      showAlert({
        alertType: 'success',
        message: iFMessage({ intl, id: 'contracts.alert.delete.success' }),
        dismissable: true,
      });
    });
  };
  const handleRemoveContract = () => {
    const { contractType, id } = dataToRemove;
    removeContract(contractType, id);
    toggleRemove();
  };

  const toggleModal = () => toggleEditModal(!isEditModalOpen);
  const handleSelectContract = (contract) => selectContract(contract);

  const handleEdit = (id, type) => {
    handleSelectContract(contracts[type.toLowerCase()][id]);
    toggleModal();
  };

  const renderItemHeader = (el) => {
    return (
      <div className="accordion-item-header">
        <p>{el.name}</p>
        {el.props.status === 1 && (
          <span className="contracts-status-block">
            <FMessage id="contracts.item.not-sent" />
          </span>
        )}
        <ContractStatus
          el_props={{ ...el.props, message: el.message }}
          color={getCardStatus({ props: el.props })}
        />
      </div>
    );
  };

  const getCardStatus = (el) => {
    switch (el.props.status) {
      case 50:
        return 'success'; // Активный
      case 15:
        return 'warning'; // Подписание и отправка
      case 5:
        return 'warning'; // Документы находятся на проверке
      case 1:
        return ''; // Редактирование
      case -100:
        return 'danger'; // Ошибка
      default:
        return '';
    }
  };

  const getLabelId = (key, type) => {
    const { labelId } = fieldProps[key];
    const customLabelId = customLabelIds[type.toLowerCase()][key];
    if (customLabelId !== undefined) {
      return `contracts.${labelId[customLabelId]}`;
    }
    const realLabelId = Array.isArray(labelId) ? labelId[type] : labelId;
    return `contracts.${realLabelId}`;
  };

  const renderCardBody = ({ props, type, id, message, ...el }) => {
    const body = Object.keys(el).map((elKey) => {
      return el[elKey] ? (
        <tr key={elKey}>
          <td>
            <b>
              <FMessage id={getLabelId(elKey, type)} />
            </b>
          </td>
          <td>{el[elKey]}</td>
        </tr>
      ) : null;
    });

    return (
      <Fragment>
        <Table borderless size="sm" responsive>
          <tbody>{body}</tbody>
        </Table>
        <ContractStatus el_props={{ ...props, message }} color={getCardStatus({ props })} />
        <ContractShipping el_props={{ ...props, message }} />
        <ContractControls
          status={props.status}
          id={id}
          el={el}
          type={type}
          handleEdit={handleEdit}
          showAlert={showAlert}
          openRemoveModal={toggleRemove}
        />
      </Fragment>
    );
  };

  const getContractsByType = () => {
    const grouped = {};
    types.forEach((type) => {
      grouped[type] = [];
      const items = Object.keys(contracts[type] || {});
      if (items.length) {
        items.forEach((item) => {
          const el = contracts[type][item];
          grouped[type].push({
            header: renderItemHeader(el),
            cardClassName: getCardStatus(el),
            type: el.type,
            ...el,
            getLabelId: getLabelId,
            additionalComponents: (
              <>
                <ContractShipping el_props={{ ...el.props, message: el.message }} />
                <ContractControls
                  status={el.props.status}
                  id={el.id}
                  el={el}
                  type={el.type}
                  handleEdit={handleEdit}
                  showAlert={showAlert}
                  openRemoveModal={toggleRemove}
                />
              </>
            ),
          });
        });
      }
    });
    return grouped;
  };
  const getModalType = () => (selected ? selected.type.toLowerCase() : null);
  const handleSaveContract = (data) => {
    startSaveContract(getModalType(), data)
      .then(() => {
        showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'contracts.alert.edit.success' }),
          dismissable: true,
          closeInSeconds: 2,
        });
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;
          showAlert({
            alertType: 'danger',
            message: error.message,
            dismissable: true,
          });
        }
      });
  };
  const contractsByType = getContractsByType();
  // === RENDER ===
  return (
    <>
      <div className="accordion-wrapper">
        <h5>
          <FMessage id="contracts.controls.self" />
        </h5>
        {contractsByType.self && contractsByType.self.length > 0 ? (
          <Accordion items={contractsByType.self} collapsedIndex={0} />
        ) : (
          <div className="text-muted">У вас пока нет добавленных реквизитов</div>
        )}
      </div>

      <div className="accordion-wrapper">
        <h5>
          <FMessage id="contracts.controls.ip" />
        </h5>
        {contractsByType.ip && contractsByType.ip.length > 0 ? (
          <Accordion items={contractsByType.ip} collapsedIndex={0} />
        ) : (
          <div className="text-muted">У вас пока нет добавленных реквизитов</div>
        )}
      </div>

      <div className="accordion-wrapper">
        <h5>
          <FMessage id="contracts.controls.ooo" />
        </h5>
        {contractsByType.ooo && contractsByType.ooo.length > 0 ? (
          <Accordion items={contractsByType.ooo} collapsedIndex={0} />
        ) : (
          <div className="text-muted">У вас пока нет добавленных реквизитов</div>
        )}
      </div>

      <Modal toggle={toggleModal} isOpen={isEditModalOpen} size="lg" centered>
        <ModalHeader toggle={toggleModal}>
          <FMessage id="contracts.item.modal.header" />
        </ModalHeader>
        <ModalBody>
          <ContractsForm
            type={getModalType()}
            types={types}
            onSubmit={handleSaveContract}
            contracts={contracts}
            disabled={error}
            selected={selected}
            inModal={true}
            toggleModal={toggleModal}
          />
        </ModalBody>
      </Modal>
      <DialogModal
        open={isRemoveModalOpen}
        message={<FMessage id="contracts.modal.remove" />}
        onCancel={toggleRemove}
        onConfirm={handleRemoveContract}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startSaveContract: (contractType, item) => dispatch(startSaveContract(contractType, item)),
  startDeleteContract: (contractType, id) =>
    dispatch(startDeleteContract(contractType.toLowerCase(), id)),
});

export default connect(null, mapDispatchToProps)(injectIntl(AddedContracts));
